import { faker } from '@faker-js/faker';
import { FacilityType } from '@dynamika-shared/types/facility';


export function createRandomFacility(): FacilityType {
    return {
        id: faker.string.uuid(),
        name: `Cohort ${faker.string.numeric(10)}`,
        address: faker.location.streetAddress(true),
        country: faker.location.country(),
        email: faker.internet.email(),
        phone: faker.phone.imei(),
        numberOfScanners: faker.number.int(100)
    };
}

export function createRandomFacilityList(count: number): FacilityType[] {
    return faker.helpers.multiple(createRandomFacility, { count });
}

